import styled from 'styled-components';

interface ILoaderProps {
  isVisible: boolean;
}

export const Container = styled.section<ILoaderProps>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #72169b;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999999999999999 !important;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  transition: all 0.35s ease-out;

  @keyframes pulse {
    0% {
      transform: scale(0.9);
    }

    70% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.9);
    }
  }

  svg {
    overflow: visible;
    fill: #fe0b7c;
  }

  svg * {
    transform-box: fill-box;
  }

  .relative-center {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transform-origin: center center;
    margin: 0 auto;
  }

  > main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 220px;
    height: auto;
    padding: 1rem;
    animation: pulse 1.5s infinite;


    > div {
      position: absolute;

      > img {
        height: 170px;
        margin: -91px 0 0 -35px;
      }
    }

    /* TABLET */
    @media (max-width: 768px) {
      transform: scale(0.8);
    }
    
    /* MOBILE */
    @media (max-width: 480px) {
      transform: scale(0.55);

      img {
        transform: scale(0.95);
      }
    }
  }
`;

export const StyledWrapper = styled.div`
.loader {
  height: 20rem;
  width: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    zoom: 0.8;
  }
}

.react-star {
  position: relative;
  width: 15rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15rem;
  animation: rotate 3s infinite;
}

.nucleus {
  position: absolute;

  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: linear-gradient(#ffffff, #ffffff);
  height: 2rem;
  width: 2rem;
  animation: rotate 1s linear infinite;
}

.electron {
  position: absolute;
  width: 15rem;
  height: 6rem;
  border-radius: 50%;
  border: 0.3rem solid #fe157e;
  animation: revolve 1s linear infinite;
}

.electron1::before,
.electron2::before,
.electron3::before {
  content: "";
  position: absolute;
  top: 60%;
  left: 100%;
  transform: translate(-50%, -50%);
  width: 1rem;
  height: 1rem;
  background-color: cyan;
  border-radius: 50%;
  animation: moveElectron 1s infinite;
}
.electron2 {
  transform: rotate(60deg);
  animation-delay: -0.66s;
}
.electron2::before {
  animation-delay: -0.66s;
}

.electron3 {
  transform: rotate(-60deg);
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg) scale3d(1.1, 1.1, 0);
  }
}

@keyframes revolve {
  0% {
    border-color: #fe157e9c;
    border-right: transparent;
  }
  25% {
    border-color: #fe157e9c;
    border-bottom-color: transparent;
  }
  50% {
    border-color: #fe157e9c;
    border-left-color: transparent;
  }
  75% {
    border-color: #fe157e9c;
    border-top-color: transparent;
  }
  100% {
    border-color: #fe157e9c;
    border-right-color: transparent;
  }
}

@keyframes moveElectron {
  0% {
    top: 60%;
    left: 100%;
  }
  25% {
    top: 100%;
    left: 60%;
  }
  50% {
    top: 60%;
    left: 0%;
  }
  75% {
    top: 0%;
    left: 60%;
  }
  100% {
    top: 60%;
    left: 100%;
  }
}`;